module.exports = __webpack_public_path__ + "img/체이서.261a2e93.png";